// extracted by mini-css-extract-plugin
export var accordionPanel = "ProductInformation-module--accordionPanel--5dc93";
export var root = "ProductInformation-module--root--d64fe";
export var tabPanel = "ProductInformation-module--tabPanel--2f890";